import { render, staticRenderFns } from "./WaBtn.vue?vue&type=template&id=d1669162"
import script from "./WaBtn.vue?vue&type=script&lang=js"
export * from "./WaBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports